import { ITEM_STATE_DELETED } from "../../constants";

export default ({ itemState }) => itemState === ITEM_STATE_DELETED;
